import React ,{useEffect} from "react";
import AccountCard from "../stories/Cards/AccountCard";
import { useNavigate } from "react-router";
import Footer from "../components/Layout/Footer";
import { useAuth } from "../components/AuthContext/AuthContext";
import { ExclamationTriangleFill } from "react-bootstrap-icons";
import { isTrainingUser } from "../utils/utils";
import { trainingClinicalWarning } from "../utils/constants";
import useApis from "../services/useAPI";
const WelcomeContent = () => {
  const userName = localStorage.getItem("username");
  const navigate = useNavigate();
  const { setIsLoading } = useApis();
  useEffect(() => {
    setIsLoading(false)
  })
  const auth = useAuth();

  const healthCare = () => {
    navigate("/patient-record");
    localStorage.setItem("selectedService", "healthCare");
  };

  const clinical = () => {
    // Training users can only use healthcare services
    if (isTrainingUser()) {
      auth?.showToast(
        "Warning",
        trainingClinicalWarning,
        "../assets/mhc.png",
        <ExclamationTriangleFill />,
      );
      return;
    }
    navigate("/patient-record");
    localStorage.setItem("selectedService", "clinical");
  };

  return (
    <div className="welcome-content d-flex align-items-center text-center justify-content-center flex-column">
      <span className="welcome-title">Welcome {userName}</span>
      <p>Please choose an option below.</p>
      <div className="d-flex welcom-content-btn">
        <button className="col btn btn-primary" onClick={healthCare} >
          Healthcare Services
        </button>
        <button className="col btn btn-white" onClick={clinical}>
          Clinical Studies
        </button>
      </div>
    </div>
  );
};

const WelcomePage = () => {
  return (
    <div className="welcome-page-wrapper">
      <AccountCard welcomePage={true}>
        <WelcomeContent />
      </AccountCard>
      <Footer />
    </div>
  );
};

export default WelcomePage;
